__turbopack_context__.v({
  "navblock": "b33_9W_navblock",
  "navblockContainer": "b33_9W_navblockContainer",
});
